import store from './store'
import { storage } from '@/helpers/utils'

//TODO make sure our object is NOT a string
const translatedAnnouncements = storage.get('translatedAnnouncements')
const translatedMessages = storage.get('translatedMessages')
const translatedPolls = storage.get('translatedPolls')

if (
	typeof translatedAnnouncements === 'string' ||
	typeof translatedMessages === 'string' ||
	typeof translatedPolls === 'string'
) {
	init()
}

export function init() {
	storage.set('translatedAnnouncements', [])
	storage.set('translatedMessages', [])
	storage.set('translatedPolls', [])
}

export function add(message_id, is_announcement = false, is_poll = false) {
	if (is_poll) {
		const polls = storage.get('translatedPolls') || []
		polls.push(message_id)
		storage.set('translatedPolls', polls)
	} else if (is_announcement) {
		const announcements = storage.get('translatedAnnouncements') || []
		announcements.push(message_id)
		storage.set('translatedAnnouncements', announcements)
	} else {
		const messages = storage.get('translatedMessages') || []
		messages.push(message_id)
		storage.set('translatedMessages', messages)
	}
}

export function remove(message_id, is_announcement = false, is_poll = false) {
	if (is_poll) {
		const polls = storage.get('translatedPolls') || []
		const idx = polls.findIndex((t) => t === message_id)
		if (idx > -1) {
			polls.splice(idx, 1)
			storage.set('translatedPolls', polls)
		}
	} else if (is_announcement) {
		const announcements = storage.get('translatedAnnouncements') || []
		const idx = announcements.findIndex((t) => t === message_id)
		if (idx > -1) {
			announcements.splice(idx, 1)
			storage.set('translatedAnnouncements', announcements)
		}
	} else {
		const messages = storage.get('translatedMessages') || []
		const idx = messages.findIndex((t) => t === message_id)
		if (idx > -1) {
			messages.splice(idx, 1)
			storage.set('translatedMessages', messages)
		}
	}
}

export function check(message_id, is_announcement = false, is_poll = false) {
	if (is_poll) {
		let polls = storage.get('translatedPolls') || []
		if (!polls) {
			polls = []
			storage.set('translatedPolls', polls)
		}
		return polls.includes(message_id)
	} else if (is_announcement) {
		let announcements = storage.get('translatedAnnouncements') || []
		if (!announcements) {
			announcements = []
			storage.set('translatedAnnouncements', announcements)
		}
		return announcements.includes(message_id)
	} else {
		let messages = storage.get('translatedMessages') || []
		if (!messages) {
			messages = []
			messages = storage.set('translatedMessages', messages)
		}
		return messages.includes(message_id)
	}
}

export function reset() {
	storage.remove('translatedMessages')
	storage.remove('translatedAnnouncements')
	storage.remove('translatedPolls')
}

export function getMyLanguage() {
	return store.language || navigator.language.substr(0, 2)
}
